export const SET_OPEN_SIDEBAR = 'uiEffects/SET_OPEN_SIDEBAR';
